var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIntegrations = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_921",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.339294,
    y: 0.987915,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3393 21.9879C18.6893 21.9879 18.106 21.8006 17.5893 21.4259C17.0726 21.0506 16.7143 20.5712 16.5143 19.9879H11.3393C10.2393 19.9879 9.29763 19.5962 8.51429 18.8129C7.73096 18.0296 7.33929 17.0879 7.33929 15.9879C7.33929 14.8879 7.73096 13.9462 8.51429 13.1629C9.29763 12.3796 10.2393 11.9879 11.3393 11.9879H13.3393C13.8893 11.9879 14.3603 11.7919 14.7523 11.3999C15.1436 11.0086 15.3393 10.5379 15.3393 9.98792C15.3393 9.43792 15.1436 8.96691 14.7523 8.57491C14.3603 8.18358 13.8893 7.98792 13.3393 7.98792H8.16429C7.94763 8.57125 7.58529 9.05058 7.07729 9.42591C6.56863 9.80058 5.98929 9.98792 5.33929 9.98792C4.50596 9.98792 3.79763 9.69625 3.21429 9.11292C2.63096 8.52958 2.33929 7.82125 2.33929 6.98792C2.33929 6.15458 2.63096 5.44625 3.21429 4.86292C3.79763 4.27958 4.50596 3.98792 5.33929 3.98792C5.98929 3.98792 6.56863 4.17525 7.07729 4.54992C7.58529 4.92525 7.94763 5.40458 8.16429 5.98792H13.3393C14.4393 5.98792 15.381 6.37958 16.1643 7.16292C16.9476 7.94625 17.3393 8.88792 17.3393 9.98792C17.3393 11.0879 16.9476 12.0296 16.1643 12.8129C15.381 13.5962 14.4393 13.9879 13.3393 13.9879H11.3393C10.7893 13.9879 10.3186 14.1836 9.92729 14.5749C9.53529 14.9669 9.33929 15.4379 9.33929 15.9879C9.33929 16.5379 9.53529 17.0089 9.92729 17.4009C10.3186 17.7922 10.7893 17.9879 11.3393 17.9879H16.5143C16.731 17.4046 17.0936 16.9252 17.6023 16.5499C18.1103 16.1752 18.6893 15.9879 19.3393 15.9879C20.1726 15.9879 20.881 16.2796 21.4643 16.8629C22.0476 17.4462 22.3393 18.1546 22.3393 18.9879C22.3393 19.8212 22.0476 20.5296 21.4643 21.1129C20.881 21.6962 20.1726 21.9879 19.3393 21.9879ZM5.33929 7.98792C5.62263 7.98792 5.86029 7.89225 6.05229 7.70091C6.24363 7.50891 6.33929 7.27125 6.33929 6.98792C6.33929 6.70458 6.24363 6.46692 6.05229 6.27492C5.86029 6.08358 5.62263 5.98792 5.33929 5.98792C5.05596 5.98792 4.81829 6.08358 4.62629 6.27492C4.43496 6.46692 4.33929 6.70458 4.33929 6.98792C4.33929 7.27125 4.43496 7.50891 4.62629 7.70091C4.81829 7.89225 5.05596 7.98792 5.33929 7.98792Z",
    fill: "#6D675F"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIntegrations, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/integrations.a48496cc.svg";
export { ForwardRef as ReactComponent };